const highlighter = (ids, color, attempt) => {
    let a = attempt ? attempt : 0
    for (let i = 0; i < ids.length; i++) {
        let elem = document.getElementById(ids[i])
        if (elem) {
            elem.style.backgroundColor = color
        } else if(a < 5) {
            setTimeout(() => {
                highlighter(ids, color, a + 1) 
            }, 500)
        }
    }
}
export default highlighter